import { IconButton, makeStyles, Tooltip } from "@material-ui/core"
import { Deck, Edit, HomeWork, Receipt, Settings } from "@material-ui/icons"
import { useEffect } from "react"
import useAppStore from "../../../stores/AppStore"
import BotaoIntegracoes from "../Integracoes/BotaoIntegracoes"
import Segundos from "./Segundos"

const useStyles = makeStyles(theme => ({
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        flex: 2,
        gap: 2,
        "& .MuiIconButton-root": {
            color: "#5f5f5f",
            padding: 8,
        },
        [theme.breakpoints.down("sm")]: {
            justifyContent: "space-between",
        },
    },
}))

const BotoesUtilitarios = ({
    setExpandListaIntegracoes,
    expandListaIntegracoes,
    resumoDoDia,
    atualizar,
    setRegistradorModal,
    setMesaModal,
    handleBuscarDadosEstabelecimentos,
    setModalConfiguracoes,
    estabelecimentos,
}) => {
    const configuracoes = useAppStore(s => s.configuracoes)

    const classes = useStyles()

    useEffect(() => {
        handleBuscarDadosEstabelecimentos(false)
    }, [])

    const labelEstabelecimento =
        estabelecimentos?.length > 1
            ? "Estabelecimentos"
            : estabelecimentos[0]?.situacao === 0
            ? "Estabelecimento (Fechado)"
            : estabelecimentos[0]?.situacao === 1 && !estabelecimentos[0]?.pausado
            ? "Estabelecimento (Aberto)"
            : "Estabelecimento (Pausado)"

    return (
        <div className={classes.container}>
            <BotaoIntegracoes
                setExpandListaIntegracoes={setExpandListaIntegracoes}
                expandListaIntegracoes={expandListaIntegracoes}
            />

            <Tooltip title="Registrador">
                <IconButton onClick={() => setRegistradorModal(true)}>
                    <Edit />
                </IconButton>
            </Tooltip>

            <Tooltip title="Mesas">
                <IconButton onClick={() => setMesaModal(true)}>
                    <Deck />
                </IconButton>
            </Tooltip>

            <Tooltip title={labelEstabelecimento}>
                <IconButton onClick={() => handleBuscarDadosEstabelecimentos(true)}>
                    <HomeWork />
                </IconButton>
            </Tooltip>

            {configuracoes?.user?.perfil !== "DELIVERY_BASICO" && (
                <Tooltip title="Resumo do dia">
                    <IconButton onClick={resumoDoDia}>
                        <Receipt />
                    </IconButton>
                </Tooltip>
            )}

            <Segundos atualizar={atualizar} />

            <Tooltip title="Configurações">
                <IconButton onClick={() => setModalConfiguracoes(true)}>
                    <Settings />
                </IconButton>
            </Tooltip>
        </div>
    )
}

export default BotoesUtilitarios
